import { useEffect, useState, useCallback } from 'react'
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import FullScreen from '../components/FullScreen';
import apisettings from '../apiSettings';
import QRCode from "react-qr-code";
import { useTranslation } from 'react-i18next';
import { useConfig } from '../providers/ConfigProvider';
import { useFeatures } from 'flagged';
import log from 'loglevel';

const Busy = 'Busy';
const TransactionFailed = 'TransactionFailed';
const TransactionSuccess = 'TransactionSuccess';

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        background: "#00973B",
        justifyContent: "center",
        alignItems: "center",

        '& .modal': {
            padding: "48px 24px",
            background: "#fff",
            height: "auto",
            width: "508px",
            borderRadius: "12px",
            boxShadow: "0 0 1px 0 rgba(0,0,0,0.3), 0 4px 8px -2px rgba(0,0,0,0.25)",
            textAlign: "center"
        },
        '& .main-title': {
            fontSize: "35px"
        },
        '& .sub-title': {
            fontSize: "24px",
            marginTop: "5px",
        },
        '& .bottom-text': {
            fontSize: "20px",
            marginTop: "50px",
        },

        '& .MuiButtonBase-root ': {
            width: "100%",
            padding: "32px 66px",
            marginTop: "20px",
            fontSize: "20px",
            textTransform: "none"
        }
    },
}));

function PaywareSuccess() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const { StyleConfig } = useConfig();

    const [ComponentStatus, setComponentStatus] = useState(Busy);

    const [ReceiptUrl, setReceiptUrl] = useState(null);

    const features = useFeatures();

    const localGateway_GetHardwareStatus = useCallback(() => {
        window.fetch(apisettings.BASE_URL + "/GetHardwareStatus")
            .then(response => response.json())
            .then(data => {
                console.log(data);
                console.log(data.Source);
                var message = "";
                console.log(data.DispensationStatus);
                switch (data.MessageId) {
                    case "OpenLockers":
                        message = t("payware-success.open-lockers");
                        break;
                    case "OpenLockerStart":
                        message = t("payware-success.open-locker-start", { product: data.Product });
                        break;
                    case "OpenLockerSuccess":
                        message = t("payware-success.open-locker-success", { product: data.Product });
                        break;
                    case "OpenLockerFailed":
                        message = t("payware-success.open-locker-fail", { product: data.Product });
                        break;
                    case "DispenseStart":
                        message = t("payware-success.dispense-start", { count: data.Total });
                        break;
                    case "DispenseSuccess":
                        message = t("payware-success.dispense-success", { product: data.Product, row: data.PhysicalRow, column: data.PhysicalSpiral });
                        break;
                    case "DispenseFailed":
                        message = t("payware-success.dispense-fail", { product: data.Product, row: data.PhysicalRow, column: data.PhysicalSpiral });
                        break;
                    case "DispensationStatusMessage":
                        switch (data.DispensationStatus) {
                            case "DispensationReceived":
                                message = t("payware-success.dispensation-received", { product: data.Product, row: data.PhysicalRow, column: data.PhysicalSpiral });
                                break;
                            case "DispensationInCourse":
                                message = t("payware-success.dispensation-in-progress", { product: data.Product, row: data.PhysicalRow, column: data.PhysicalSpiral });
                                break;
                            case "WaitingForProductToBeCollectedByUser":
                                message = t("payware-success.customer-collection", { product: data.Product });
                                break;
                            case "ProductCollectedDispensationSuccess":
                                message = t("payware-success.product-collected", { product: data.Product });
                                break;
                            case "DispensationNotPerformed":
                            case "TokenNotFound":
                            case "DispensingQueueFull":
                                message = t("payware-success.dispense-fail", { product: data.Product, row: data.PhysicalRow, column: data.PhysicalSpiral });
                                break;
                            default:
                                break;
                        }
                        break;
                    default:
                        break;
                }
                if (message && message !== "") {
                    var elem = document.getElementById('deliveryMessage');
                    if (elem) {
                        elem.innerHTML = message;
                    }
                }
            })
            .catch(error => {
                console.log(error);
                // setShowErrorModal(true);
            });
        setTimeout(function () { localGateway_GetHardwareStatus(); }, 1000);
    }, [t]);

    useEffect(() => {
        const previousTitle = document.title;
        document.title = document.title + "-";
        return () => {
            document.title = previousTitle;
        };
    }, []);

    useEffect(() => {
        var terminalResponse = localStorage.getItem("TerminalResponse");
        localStorage.removeItem("TerminalResponse");
        // Only set for a cash payment; removed right away so it can't leak into a later pin payment.
        var cashPayment = localStorage.getItem("CashPayment");
        localStorage.removeItem("CashPayment");
        if (terminalResponse === null) {
            log.info('Prevented dispense without payment, redirecting to new session');
            setTimeout(function () {
                document.location.href = '/index.html#/newsession';
            }, 100);
            return;
    }
        // Put request to Local gateway api (payment was successfull)
        console.log("Payment Success!")
        if (features.ursereceipt) {
            var req = localStorage.getItem("SendTransactionReqBody");

            const request = {
                transaction: JSON.parse(req),
                terminalPaymentResponse: JSON.parse(terminalResponse),
                cashPayment: cashPayment ? JSON.parse(cashPayment) : null
            };

            console.log("request data: ", request);
            sendTransactionWithEReceiptToBackend(JSON.stringify(request));
        }
        else {
            localGateway_PaymentSuccessfull();
            setReceiptUrl(localStorage.getItem("ReceiptUrl"));
        }
        setTimeout(function () { localGateway_GetHardwareStatus(); }, 1000);
    }, [localGateway_GetHardwareStatus, features.ursereceipt]);

    async function localGateway_PaymentSuccessfull() {
        // original post before e-receipt
        var req = localStorage.getItem("SendTransactionReqBody");

        var xhr = new XMLHttpRequest();

        xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
                console.log(this);
                // check on responseText (fallback for any errors after Transaction has been sent)
                if (this.responseText) {
                    console.log('Transaction failed: ' + this.responseText);
                    setComponentStatus(TransactionFailed);
                }
                else {
                    console.log('Transaction sent');
                    setComponentStatus(TransactionSuccess);
                    // set timeout, this way the customer has at least 25 seconds to read the 'transaction voltooid' screen
                    setTimeout(function () { document.location.href = '/index.html#/newsession' }, 25000);
                }
            }
        });

        xhr.open("PUT", apisettings.BASE_URL + "/SendTransaction");
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.send(req);
    }

    async function sendTransactionWithEReceiptToBackend(req) {
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: req
        };
        fetch(apisettings.BASE_URL + "/SendTransactionWithEReceipt?lang=" + i18n.language, requestOptions)
            .then((response) => {
                if (response.ok) {
                    setComponentStatus(TransactionSuccess);
                    // set timeout, this way the customer has at least 25 seconds to read the 'transaction voltooid' screen
                    setTimeout(function () { document.location.href = '/index.html#/newsession' }, 25000);
                }
                else {
                    setComponentStatus(TransactionFailed);
                }
                return response.json();
            })
            .then((data) => {
                if (data) {
                    setReceiptUrl(data.EReceiptUrl);
                }
            })
            .catch(error => {
                console.log(error);
                setComponentStatus(TransactionFailed);
            });;
    }

    return (
        <FullScreen>
            <div id="PaywareSuccess" className={classes.root} style={StyleConfig?.TerminalInstructionPageBackgroundStyle ?? {}} >
                <h1>{ComponentStatus}</h1>
                {ComponentStatus === Busy || ComponentStatus === TransactionSuccess ?
                    <div className="modal">
                        <h1 className="main-title">{t("payware-success.transaction-complete")}</h1>
                        {ReceiptUrl ?
                            <>
                                <h3 className="sub-title">{t("payware-success.scan-qr-code")}</h3>
                                <QRCode value={ReceiptUrl} style={{ margin: '10px' }} />
                            </>
                            :
                            <h3 className="sub-title">{t("payware-success.no-qr-code")}</h3>
                        }
                        <h3 className="sub-title">{t("payware-success.purchase-dispensing")}</h3>
                        <h3 className="sub-title">{t("payware-success.locker-light-flicker")}</h3>

                        <h1 className="main-title" id="deliveryMessage"> </h1>

                        <h4 className="bottom-text">
                            {t("payware-success.help-text")}<br />{t('contact.optionandname')}
                        </h4>
                        <h3 className="sub-title">{t('contact.optiondetails')}</h3>
                        {ComponentStatus === TransactionSuccess ?
                            <Button
                                type="button"
                                className="darkgreen-btn"
                                style={StyleConfig?.DefaultButtonColorStyle ?? {}}
                                variant="contained"
                                color="primary"
                                onClick={() => document.location.href = '/index.html#/newsession'}>{t("payware-success.next")}
                            </Button> : null}
                    </div>
                    :
                    <div className="modal">
                        <h1 className="main-title">{t("payware-success.product-not-dispensed-1")} 😔</h1>
                        {ReceiptUrl ?
                            <>
                                <h3 className="sub-title">{t("payware-success.scan-qr-code")}</h3>
                                <QRCode value={ReceiptUrl} style={{ margin: '10px' }} />
                            </>
                            :
                            <h3 className="sub-title">{t("payware-success.no-qr-code")}</h3>
                        }
                        <h3 className="sub-title">{t("payware-success.product-not-dispensed-2")}</h3><br />
                        <h4 className="bottom-text">
                            {t("payware-success.help-text")}<br />{t('contact.optionandname')}
                        </h4>
                        <h3 className="sub-title">{t('contact.optiondetails')}</h3>
                        <h3 className="sub-title">{t("payware-success.we-fix")}</h3>
                        <Button
                            type="button"
                            className="darkgreen-btn"
                            style={StyleConfig?.DefaultButtonColorStyle ?? {}}
                            variant="contained"
                            color="primary"
                            onClick={() => document.location.href = '/index.html#/newsession'}>{t("payware-success.next")}
                        </Button>
                    </div>
                }
            </div>
        </FullScreen>
    )
}

export default PaywareSuccess
